import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Leaderboard from "@/pages/Leaderboard";
import PlayerDetail from "@/pages/PlayerDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0B] text-[#F0E6D2] flex flex-col">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <main data-testid="app-main" className="flex-1">
            <Routes>
              <Route path="/" element={<Leaderboard />} />
              <Route path="/player/:id" element={<PlayerDetail />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminPanel />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#121214",
                border: "1px solid #2A2A30",
                color: "#F0E6D2",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
